export default __webpack_public_path__ + "static/image6-97795b3c82c15e98b0b43914ba7f80c6.jpg";